import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router'
import ElementUI from 'element-ui';

import 'lib-flexible/flexible.js'

import 'element-ui/lib/theme-chalk/index.css';

// axios.defaults.baseURL = "/api/"
axios.interceptors.response.use(res => {

	if (!!res.data && res.data.Status != 1) {
		return Promise.reject(res.data.Message);
	}
	return res.data;
}, error => {
	return Promise.reject(error);
})

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
